import { ReactElement, useState } from 'react';
import { usePDPAttributeHistoryQuery } from 'common/hooks/api/queries/use-content-query';
import { PdpHistoryContent } from './pdp-history-content';

const PAGE_SIZE = 10;

interface Props {
  pid: string;
  open: boolean;
}

export function NonTargetHistory({ pid, open }: Props): ReactElement {
  const { data: historyData, isFetching: isHistoryLoading } = usePDPAttributeHistoryQuery({ pid }, open);
  const [page, setPage] = useState(0);

  const items = historyData?.items ?? [];
  const total = items.length;
  const paginatedItems = items
    .sort((a, b) => new Date(b.generatedAt).getTime() - new Date(a.generatedAt).getTime())
    .slice(page * PAGE_SIZE, (page + 1) * PAGE_SIZE);

  return (
    <PdpHistoryContent
      history={paginatedItems}
      isHistoryLoading={isHistoryLoading}
      total={total}
      page={page}
      pageSize={PAGE_SIZE}
      onPageChange={setPage}
      skipSort
    />
  );
}
